/**
 * Creates a composite key from domain and feature
 */
export const createCompositeKey = (domain: string, feature: string): string =>
  `${domain}|${feature}`;
